import "./utils";
const pageTemplate = params.page_template?.replace(/^.*\/([^/]+)\.php$/, "$1");

// Перевіряємо, чи є елемент з класом 'swiper' на сторінці
if (document.querySelector(".swiper")) {
  import("./swipers/main").catch((error) => {
    console.error("Failed to load Swiper module:", error);
  });
}
if (document.querySelector(".backdrop")) {
  import("./popups/main").catch((error) => {
    console.error("Failed to load Popups module:", error);
  });
}
if (document.querySelector("#dripsCatalog")) {
  import("./droppersCatalog").catch((error) => {
    console.error("Failed to load droppers logic:", error);
  });
}
if (document.querySelector("form")) {
  import("./integration/index").catch((error) => {
    console.error("Failed to load Form module:", error);
  });
}

import "./events/main";
import "./showMore";
import "./langSwitcher";
import "./scrollTop";

import "../css/main.scss";
